Ext.define('SA.view.quickreport.QuickReportScrollSynchronizer', {
    alias: 'quickreport.scroll-synchronizer',

    constructor(view) {
        this.view = view;
    },

    destroy() {
        this.view = null;
    },

    get(selector) {
        return this.view.el.down(selector, true);
    },

    getBody() {
        return this.get('.sa-quick-report-body-wrap');
    },

    getFirstCol() {
        return this.get('.sa-quick-report-first-col');
    },

    initEvents() {
        var viewEl = this.view.el,
            viewNode = viewEl.dom;

        viewNode.addEventListener('scroll', this.onScroll.bind(this), true);
        viewNode.addEventListener('wheel', this.onWheel.bind(this), true);

        viewEl.on('mousedown', this.onBodyMouseDown, this, {delegate: '.sa-quick-report-body-wrap'});
        viewEl.on('mousedown', this.onFirstColMouseDown, this, {delegate: '.sa-quick-report-first-col'});
    },

    onBodyMouseDown() {
        this.setScrollSourceIsBody(true);
    },

    onFirstColMouseDown() {
        this.setScrollSourceIsBody(false);
    },

    onScroll() {
        if (this.scrollSourceIsBody) {
            this.syncAllToBody();
        }
        else {
            this.syncBodyToFirstCol();
        }
    },

    onWheel(ev) {
        var body = this.getBody(),
            sourceIsBody = Ext.fly(body).contains(ev.target);

        this.setScrollSourceIsBody(sourceIsBody);
    },

    scrollLeftBy(delta) {
        this.setScrollLeft(this.getBody().scrollLeft + delta);
    },

    setScrollLeft(scrollLeft) {
        this.getBody().scrollLeft = scrollLeft;

        this.syncHeaderToBody();
    },

    setScrollSourceIsBody(bool) {
        this.scrollSourceIsBody = bool;
    },

    syncAllToBody() {
        this.syncHeaderToBody();
        this.syncFirstColToBody();
    },

    syncBodyToFirstCol() {
        this.getBody().scrollTop = this.getFirstCol().scrollTop;
    },

    syncFirstColToBody() {
        this.getFirstCol().scrollTop = this.getBody().scrollTop;
    },

    syncHeaderToBody() {
        var header = this.get('.sa-quick-report-header'),
            bodyScrollLeft = this.getBody().scrollLeft,
            headerX = 0 - bodyScrollLeft;

        header.style.transform = 'translate(' + headerX + 'px, 0)';
    }
});